import React from "react";
import {Link, useParams} from "react-router-dom";

import {PermissionEditComponent} from "ppm-react-authentication";
import {PERMISSIONS_API_URL} from "../../helpers/api-urls";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next";

const PagesEditPermissions  = (props) =>{

    const {history} = props;
    const params = useParams();
    const {id = 0} = params;
    const onEditSuccess = (response) => {
        history.push("/pages-permissions");
    }
    return (
        <>
            <div className="page-content">
                    <title>{props.t("PERMISSION")}</title>

                <div className="mb-4">
                    <Breadcrumbs title="Permission" breadcrumbItem={props.t("PERMISSION") + " - " + ( id ? props.t("MODIFICATION")  : props.t("ADD"))}/>
                    <Link className="btn btn-info" to={"/pages-permissions"}>{props.t("RETURN_TO_LIST")}</Link>
                </div>
                <PermissionEditComponent 
                    id={id}
                    onEditSuccess={onEditSuccess}
                    apiUrl={PERMISSIONS_API_URL}
                    addUrl="/pages-permissions/add"
                    path="/pages-permissions"
                />
            </div>
        </>
    )
}

export default withTranslation()(PagesEditPermissions)
